import styled from '@emotion/styled'
export const StyleImageWrapper = styled.div<{
  direction?: string
  flex?: number
  widthsm?: string
  heightsm?: string
}>`
  width: 100%;
  height: 100%;
  flex: ${(props) => props.flex || 1.1};
  display: flex;
  justify-content: ${(props: any) =>
    props.direction === 'reverse'
      ? 'flex-end'
      : props.direction === 'center'
        ? 'center'
        : 'flex-start'};
  img {
    max-width: 100%;
    height: 100%;
    object-fit: contain;
  }
  @media (max-width: 480px) {
    width: ${(props: any) => props.widthsm || '50%'};
    height: ${(props: any) => props.heightsm || '50%'};
  }
`
